import { CategoryKey } from '@seatsio/seatsio-react';

import { hasSeatedItems } from 'utils/ticket.utils';

import { CartFragment } from 'types/api/tickets.types';
import {
  Categories,
  LocalCartItem,
  SeatingCategory,
  SeatingToken,
} from 'types/tickets.types';

export const mapMatchingSeatedTickets = (
  categories: Categories,
  chartKey: string,
): Array<SeatingCategory & { timeslots: Array<string> }> =>
  categories.reduce<Array<SeatingCategory & { timeslots: Array<string> }>>(
    (acc, category) => {
      category.tickets.forEach((t) => {
        if (t.seatingData?.seatingChartEventOrSeasonId === chartKey) {
          acc.push({
            ticketId: t.id,
            name: t.name,
            categoryKey: t.seatingData.seatingCategoryKey,
            timeslots: t.timeslots?.map((t) => t.dateTimeRange.start) ?? [],
          });
        }
      });
      return acc;
    },
    [],
  );

/**
 * Check if cart has any discount applied by checking cart modifiers
 * @param modifiers
 */
export const cartHasDiscount = (
  modifiers: CartFragment['modifiers'] | null,
) => {
  return modifiers?.find((item) => {
    return item?.type === 'CartTotalDiscount' && item?.value > 0;
  });
};

/**
 * Ticketing API exposes categoryKeys as strings, but Seats.io expects string or number.
 * Use this function when interacting with Seats.io to ensure compatibility.
 */
export const castStringToCategoryKey = (categoryKey: string): CategoryKey => {
  const num = Number(categoryKey);
  return isNaN(num) ? categoryKey : num;
};

export const getHoldToken = (
  seatingToken: SeatingToken | undefined,
  cartItems: Array<LocalCartItem>,
) => {
  // Only pass a holdToken if we have it not expired and we have seated items
  if (!seatingToken || seatingToken.expired || !hasSeatedItems(cartItems)) {
    return undefined;
  }

  return seatingToken.token;
};
